<router-outlet></router-outlet>
<ngx-spinner>
  <div class="loader-container">
    <div class="loader">
      <span class="loader1"></span>
      <span class="loader2"></span>
      <span class="loader3"></span>
      <span class="loader4"></span>
    </div>
    <div class="loading-text fw-bold">Loading...</div>
  </div>
</ngx-spinner>
